var default_styles_default = {
  "button_container": "JomUn",
  "button_margin": "vXbXK",
  "button_text": "_1GmQs",
  "button_size_content": "m46KY"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
